import { Atom } from 'AppReact';
import styled, { css } from "styled-components";

const template = styled.div`
    border: 1px solid ${window?.settings?.primary_color ?? '#1DBD6B'};
    border-radius: 50%;
    width: 16px;
    height: 16px;
    background: #FFFFFF;
    padding: 3px 3px;
    ${({ displayState }) => displayState.selected && css`
        &:before {
            content: "";
            display: block;
            width: 8px;
            height: 8px;
            background: ${window?.settings?.primary_color ?? '#1DBD6B'};
            border-radius: 50%;
        }
    `}
    
`;


export default Atom({ type: 'button', dataType: 'boolean', template })